import { IAccountCode } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

export const accountCodeApi = crudEndpointsFactory<IAccountCode>()('account-codes', 'AccountCodes');
